import { Component, EventEmitter, Input, Output } from '@angular/core';
import { fromSize, fromVisibility, Size, Visibility } from '../buttons-utils';

@Component({
    selector: 'a-button-icon',
    templateUrl: './a-button-icon.component.html',
    styleUrls: ['./a-button-icon.component.scss'],
    standalone: false
})
export class AButtonIconComponent {

    @Input()
    public disabled = false;

    @Input()
    public type: 'button' | 'submit' = 'button';

    @Input()
    public visibility: Visibility = 'MEDIUM';

    @Input()
    public size: Size = 'DEFAULT';

    @Input()
    public tabindex = 0;

    // tslint:disable-next-line:no-output-native
    @Output()
    public click: EventEmitter<MouseEvent> = new EventEmitter();

    public fromVisibility = fromVisibility;
    public fromSize = fromSize;

    public doAction(event: MouseEvent): void {
        event.stopPropagation();
        if (!this.disabled) {
            this.click.emit(event);
        }
    }

}
